import api from "@/lib/api";

export async function prepareFacebookCard(blob, source) {
  if (!blob) throw new Error("Your image is preparing. Try Facebook again in a moment.");
  const image = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(",")[1]);
    reader.onerror = () => reject(new Error("Couldn't prepare your image. Try again."));
    reader.readAsDataURL(blob);
  });
  const { data } = await api.post("/shares", { ...source, image });
  if (!/^\/api\/shares\/[a-f0-9]{40}$/.test(data.path)) throw new Error("Couldn't prepare the Facebook link.");
  return `${window.location.origin}${data.path}`;
}
